import { AnalysisBlockProps, AnalysisResultBlockProps } from '@/pages/ExperienceProjectDetailPage/components/AnalysisFlowView/AnalysisBlock/AnalysisBlock'
import SubAnalysisDescriptionPopover from '@/pages/ProjectDetailPage/components/VideoAnalysis/SubAnalysisDescriptionPopover/SubAnalysisDescriptionPopover'
import { useTranslation } from 'react-i18next'

function useI18nFlowAnalysisTips() {
  const { t } = useTranslation()
  const FLOW_ANALYSIS_PREFIX = 'dashboard.experience.projectDetailPage.flowAnalysis'
  /************************************ 热力图分析提示 ************************************/
  const HEATMAP_TIPS: AnalysisBlockProps[] = [
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.desc1`),
      content: [],
      status: 'completed'
    },
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.desc2`),
      content: [],
      status: 'completed'
    },
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.desc3`),
      content: [
        { title: t(`${FLOW_ANALYSIS_PREFIX}.desc4`), status: 'completed' },
        { title: t(`${FLOW_ANALYSIS_PREFIX}.desc5`), status: 'completed' },
      ],
      status: 'completed'
    },
  ]

  const HEATMAP_MEDIA: AnalysisResultBlockProps = {
    title: t(`${FLOW_ANALYSIS_PREFIX}.desc6`),
    type: 'media',
    content: null
  }

  /************************************ 主观反应曲线分析提示 ************************************/

  const SUBJECTIVE_RESPONSE_CURVE_TIPS: AnalysisBlockProps[] = [
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.desc7`),
      content: [
        { title: t(`${FLOW_ANALYSIS_PREFIX}.desc8`), status: 'completed' },
        { title: t(`${FLOW_ANALYSIS_PREFIX}.desc9`), status: 'completed' },
      ],
      status: 'completed'
    },
  ]

  const SUBJECTIVE_RESPONSE_CURVE_MEDIA: AnalysisResultBlockProps = {
    title: t(`${FLOW_ANALYSIS_PREFIX}.desc10`),
    type: 'media',
    content: null
  }

  /************************************ 指标分析提示 ************************************/

  const INDEX_ANALYSES_TIPS: AnalysisBlockProps[] = [
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.desc11`),
      content: [
        { title: t(`${FLOW_ANALYSIS_PREFIX}.desc12`), status: 'completed' },
        { title: t(`${FLOW_ANALYSIS_PREFIX}.desc13`), status: 'completed' },
      ],
      status: 'completed'
    },
  ]

  const POPOVER_DESC = [
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.terminology.gazeRecognition`),
      description: t(`${FLOW_ANALYSIS_PREFIX}.terminology.gazeRecognitionDesc`),
    },
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.terminology.engagementRecognition`),
      description: t(`${FLOW_ANALYSIS_PREFIX}.terminology.engagementRecognitionDesc`),
    },
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.terminology.emotionRecognition`),
      description: t(`${FLOW_ANALYSIS_PREFIX}.terminology.emotionRecognitionDesc`),
    },
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.terminology.theGolden3Seconds`),
      description: t(`${FLOW_ANALYSIS_PREFIX}.terminology.theGolden3SecondsDesc`),
    },
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.terminology.keyMessage`),
      description: t(`${FLOW_ANALYSIS_PREFIX}.terminology.keyMessageDesc`),
    },
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.terminology.brand`),
      description: t(`${FLOW_ANALYSIS_PREFIX}.terminology.brandDesc`),
    },
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.terminology.interest`),
      description: t(`${FLOW_ANALYSIS_PREFIX}.terminology.interestDesc`),
    },
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.terminology.ending3Seconds`),
      description: t(`${FLOW_ANALYSIS_PREFIX}.terminology.ending3SecondsDesc`),
    },
  ]

  const INDEX_ANALYSES_MEDIA: AnalysisResultBlockProps = {
    title: <div>
      <span style={{ marginRight: 4 }}>{t(`${FLOW_ANALYSIS_PREFIX}.desc14`)}</span>
      <SubAnalysisDescriptionPopover descriptions={POPOVER_DESC} />
    </div>,
    type: 'media',
    content: null
  }

  /************************************ 消费者态度分析提示 ************************************/

  const CONSUMER_ATTITUDE_ANALYSIS_TIPS: AnalysisBlockProps[] = [
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.desc15`),
      content: [
        { title: t(`${FLOW_ANALYSIS_PREFIX}.desc16`), status: 'completed' },
        { title: t(`${FLOW_ANALYSIS_PREFIX}.desc17`), status: 'completed' },
      ],
      status: 'completed'
    },
  ]

  const CONSUMER_ATTITUDE_POPOVER_DESC = [
    'liking',
    'newInformation',
    'messageRelevance',
    'comprehension',
    'credibility',
    'brandLinkage',
    'uniqueness',
    'willing',
    'purchase',
    'share',
    'brandLikeLift',
    'purchaseIntentLift',
  ].map((key) => ({
    title: t(`${FLOW_ANALYSIS_PREFIX}.terminology.attitudePart.${key}`),
    description: t(`${FLOW_ANALYSIS_PREFIX}.terminology.attitudePart.${key}Desc`),
  }))

  const FIVE_DIMENSION_POPOVER_DESC = [
    'attentionForce',
    'emotionalForce',
    'messageForce',
    'brandForce',
    'persuasiveForce',
  ].map((key) => ({
    title: t(`${FLOW_ANALYSIS_PREFIX}.terminology.dimensionPart.${key}`),
    description: t(`${FLOW_ANALYSIS_PREFIX}.terminology.dimensionPart.${key}Desc`),
  }))

  const FINAL_RESULT_POPOVER_DESC = [
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.terminology.result.adeffScore`),
      description: t(`${FLOW_ANALYSIS_PREFIX}.terminology.result.adeffScoreDesc`),
    },
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.terminology.benchmark`),
      description: t(`${FLOW_ANALYSIS_PREFIX}.terminology.result.benchmarkDesc`),
    },
  ]

  const CONSUMER_ATTITUDE_ANALYSIS_MEDIA: AnalysisResultBlockProps = {
    title: <div>
      <span style={{ marginRight: 4 }}>{t(`${FLOW_ANALYSIS_PREFIX}.desc18`)}</span>
      <SubAnalysisDescriptionPopover descriptions={CONSUMER_ATTITUDE_POPOVER_DESC} />
    </div>,
    type: 'media',
    content: null
  }

  const FIVE_DEMENSION_BENEFITS_TIPS: AnalysisBlockProps[] = [
    {
      title: t(`${FLOW_ANALYSIS_PREFIX}.desc19`),
      content: [],
      status: 'completed'
    },
  ]

  const FIVE_DEMENSION_BENEFITS_MEDIA: AnalysisResultBlockProps = {
    title: <div>
      <span style={{ marginRight: 4 }}>{t(`${FLOW_ANALYSIS_PREFIX}.desc20`)}</span>
      <SubAnalysisDescriptionPopover descriptions={FIVE_DIMENSION_POPOVER_DESC} />
    </div>,
    type: 'media',
    content: null
  }

  /************************************ 核心结果分析提示 ************************************/

  const FINAL_RESULT_MEDIA: AnalysisResultBlockProps = {
    title: <div>
      <span style={{ marginRight: 4 }}>{t(`${FLOW_ANALYSIS_PREFIX}.desc21`)}</span>
      <SubAnalysisDescriptionPopover descriptions={FINAL_RESULT_POPOVER_DESC} />
    </div>,
    type: 'end',
    content: null
  }

  return {
    HEATMAP_TIPS,
    HEATMAP_MEDIA,
    SUBJECTIVE_RESPONSE_CURVE_TIPS,
    SUBJECTIVE_RESPONSE_CURVE_MEDIA,
    INDEX_ANALYSES_TIPS,
    INDEX_ANALYSES_MEDIA,
    CONSUMER_ATTITUDE_ANALYSIS_TIPS,
    CONSUMER_ATTITUDE_ANALYSIS_MEDIA,
    FIVE_DEMENSION_BENEFITS_TIPS,
    FIVE_DEMENSION_BENEFITS_MEDIA,
    FINAL_RESULT_MEDIA,
  }
}

export default useI18nFlowAnalysisTips
